var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',{attrs:{"fluid":true}},[_c('formulario-oferta',{attrs:{"id":Number(_vm.$route.params.id)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }